import {Component} from '@angular/core';
import {
  PersonalInformationEditCardType
} from "../../layouts/personal-information-edit-card/personal-information-edit-card-type.enum";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FilesUtil} from "../../../util/files.util";
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'app-profile-personal-information',
  templateUrl: './profile-personal-information.component.html',
  styleUrls: ['./profile-personal-information.component.css']
})
export class ProfilePersonalInformationComponent {

  protected readonly currentUserId: string | null;

  // todo: set default image path, or remove when func will be implemented
  private readonly dummyImageSrc = 'assets/images/avatar/avatar-11.jpg';

  protected profileForm: FormGroup;
  protected selectedImgFile: File | null = null;
  protected profilePictureSrc: string = this.dummyImageSrc;
  protected selectedEditCardType: PersonalInformationEditCardType | null = null;

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService
  ) {
    this.currentUserId = this.authService.getCurrentUserId();
    this.profileForm = this.getProfileForm();
  }

  onPhotoUpload(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (FilesUtil.isFilesSizeValid(input.files)) {
      const file = input.files![0];
      if (file.size > FilesUtil.MAX_FILE_SIZE) {
        alert('Image size should not exceed 800KB.');
        return;
      }

      this.selectedImgFile = file;

      const reader: FileReader = new FileReader();
      reader.onload = () => {
        this.profilePictureSrc = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  removePhoto(): void {
    this.selectedImgFile = null;
    this.profilePictureSrc = this.dummyImageSrc;
  }

  submit(changedData: FormGroup): void {
    if (changedData.valid) {
      // TODO: Send data to backend
    }
  }

  resetFormToDefault() {
    this.profileForm = this.getProfileForm();
  }

  private getProfileForm() {
    return this.fb.group({
      firstName: ['dummy', [Validators.required, Validators.maxLength(50)]],
      lastName: ['dummy', [Validators.required, Validators.maxLength(50)]],
      email: ['dummy@gmail.com', [Validators.required, Validators.email]],
      phone: ['+374 99 999999', [Validators.required]],
      password: ['dummy', [Validators.required, Validators.minLength(6)]]
    });
  }

  protected readonly PersonalInformationEditCardType = PersonalInformationEditCardType;
  protected readonly IMAGE_ACCEPT_FORMATS = FilesUtil.IMAGE_ACCEPT_FORMATS;
}
